<template>
  <div class="page flex-col">
    <div class="group_1 flex-col">
      <div class="block_1 flex-row">
        <img class="image_1" referrerpolicy="no-referrer" src="../../assets/img/head_logo.png" />
        <div class="nav-item" @click="goHome()">
          <span class="nav-text">首页</span>
          <span class="nav-line"></span>
        </div>
        <div class="nav-item" @click="goProduct()">
          <span class="nav-text">产品中心</span>
          <span class="nav-line"></span>
        </div>
        <div class="nav-item active">
          <span class="nav-text">服务中心</span>
          <span class="nav-line"></span>
        </div>
        <div class="nav-item" @click="goAbout()">
          <span class="nav-text">关于我们</span>
          <span class="nav-line"></span>
        </div>
        <img class="thumbnail_1" referrerpolicy="no-referrer" src="../../assets/img/head_phone.png" />
        <div class="text-wrapper_1">
          <span class="text_5">联系我们：</span>
          <span class="text_6">4000506688</span>
        </div>
      </div>
      <div class="group_11 flex-col">
        <div class="box_4 flex-col">
          <div class="group_12 flex-row">
            <div class="group_3 flex-col">
              <div class="group_13 flex-row justify-between">
                <img
                  class="image_1"
                  referrerpolicy="no-referrer"
                  src="./assets/img/d020f9b41e50f75cabfb256f8c08b13d.png"
                />
                <div class="text-wrapper_1 flex-col"><span class="text_1">服务网络</span></div>
              </div>
              <span class="text_2">全国多区域覆盖，就近响应，高效对接您的多样化需求。</span>
            </div>
            <div class="group_4 flex-col">
              <div class="box_6 flex-row justify-between">
                <img
                  class="image_2"
                  referrerpolicy="no-referrer"
                  src="./assets/img/82c1607a16d7b327f044370fd5545664.png"
                />
                <div class="text-wrapper_2 flex-col"><span class="text_3">核心服务</span></div>
              </div>
              <span class="text_4">提供安装调试、故障维修、运维升级、技术咨询等专业支持。</span>
            </div>
            <div class="group_6 flex-col">
              <div class="box_7 flex-row justify-between">
                <img
                  class="image_3"
                  referrerpolicy="no-referrer"
                  src="./assets/img/f3d42b9f90a446dd3db788bb858a2129.png"
                />
                <div class="text-wrapper_3 flex-col"><span class="text_5">服务承诺</span></div>
              </div>
              <span class="text_6">建立快速响应通道，第一时间出具解决方案，对接多样化需求。</span>
            </div>
          </div>
          <div class="group_14 flex-row">
            <div class="block_2 flex-col">
              <div class="section_1 flex-row justify-between">
                <img
                  class="image_4"
                  referrerpolicy="no-referrer"
                  src="./assets/img/fb32949590a38365ab0ee545e960ca71.png"
                />
                <div class="text-wrapper_4 flex-col"><span class="text_7">专业团队</span></div>
              </div>
              <span class="text_8">眼视光与医疗器械领域资深工程师,实践经验丰富,技术能力过硬。</span>
            </div>
            <div class="block_4 flex-col">
              <div class="box_8 flex-row justify-between">
                <img
                  class="image_5"
                  referrerpolicy="no-referrer"
                  src="./assets/img/66741f63e2c3afdcf535e42a5087a5c8.png"
                />
                <div class="text-wrapper_5 flex-col"><span class="text_9">远程支持</span></div>
              </div>
              <span class="text_10">支持上门现场服务/线上远程协助,灵活应对各类技术问题。</span>
            </div>
            <div class="block_5 flex-col">
              <div class="section_2 flex-row justify-between">
                <img
                  class="image_6"
                  referrerpolicy="no-referrer"
                  src="./assets/img/98060fdbc81c5a7f4a77257f57406a5a.png"
                />
                <div class="text-wrapper_6 flex-col"><span class="text_11">服务面向</span></div>
              </div>
              <span class="text_12">服务于眼科机构、视光中心、眼镜门店、医疗机构及相关单位。</span>
            </div>
          </div>
        </div>
        <div class="text-wrapper_7 flex-col"><span class="text_13">匠心铸就品质，服务创造信赖</span></div>
      </div>
      <div class="box_5 flex-col"></div>
      <div class="bottom_box flex-row">
        <img class="image_11" referrerpolicy="no-referrer" src="../../assets/img/bottom_phone.png" />
        <div class="text-wrapper_20 flex-col justify-between">
          <span class="text_40">联系我们：</span>
          <span class="text_41">400&nbsp;050&nbsp;6688</span>
          <div class="network-keycord">津ICP备2021007957号-1</div>
        </div>
        <div class="image-text_11 flex-col justify-between">
          <img class="image_12" referrerpolicy="no-referrer" src="../../assets/img/bottom_ercode1.png" />
          <span class="text-group_5">视频号</span>
        </div>
        <div class="image-text_12 flex-col justify-between">
          <img class="image_13" referrerpolicy="no-referrer" src="../../assets/img/bottom_ercode2.png" />
          <span class="text-group_6">公众号</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      constants: {}
    };
  },
  mounted() {
    this.injectStructuredData();
  },
  beforeDestroy() {
    this.removeStructuredData();
  },
  methods: {
    // 注入结构化数据供 AI 爬虫抓取
    injectStructuredData() {
      // 面包屑导航
      const breadcrumbData = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "首页",
            "item": "https://test.uyu.com/uyu_home"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "服务中心",
            "item": "https://test.uyu.com/uyu_service"
          }
        ]
      };

      // 服务中心页面信息
      const servicePageData = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "优眼智家服务中心",
        "url": "https://test.uyu.com/uyu_service",
        "description": "优眼智家服务中心，提供专业的眼健康咨询服务和技术支持。全国多区域覆盖，就近响应，高效对接您的多样化需求。",
        "isPartOf": {
          "@type": "WebSite",
          "name": "优眼智家官网",
          "url": "https://test.uyu.com"
        }
      };

      // 核心服务列表
      const coreServicesData = {
        "@context": "https://schema.org",
        "@type": "ItemList",
        "name": "优眼智家核心服务",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "服务网络",
            "description": "全国多区域覆盖，就近响应，高效对接您的多样化需求"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "核心服务",
            "description": "提供安装调试、故障维修、运维升级、技术咨询等专业支持"
          },
          {
            "@type": "ListItem",
            "position": 3,
            "name": "服务承诺",
            "description": "建立快速响应通道，第一时间出具解决方案，对接多样化需求"
          },
          {
            "@type": "ListItem",
            "position": 4,
            "name": "专业团队",
            "description": "眼视光与医疗器械领域资深工程师，实践经验丰富，技术能力过硬"
          },
          {
            "@type": "ListItem",
            "position": 5,
            "name": "远程支持",
            "description": "支持上门现场服务/线上远程协助，灵活应对各类技术问题"
          },
          {
            "@type": "ListItem",
            "position": 6,
            "name": "服务面向",
            "description": "服务于眼科机构、视光中心、眼镜门店、医疗机构及相关单位"
          }
        ]
      };

      // 服务详情
      const serviceData = {
        "@context": "https://schema.org",
        "@type": "Service",
        "name": "优眼智家眼健康服务",
        "description": "为医疗机构、视光中心及个人提供从视功能检查到视觉训练的一站式智能化解决方案",
        "provider": {
          "@type": "Organization",
          "name": "天津新视光技术有限公司",
          "alternateName": "优眼智家",
          "telephone": "400-050-6688",
          "url": "https://test.uyu.com"
        },
        "serviceType": "眼健康管理服务",
        "areaServed": {
          "@type": "Country",
          "name": "中国"
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "name": "综合服务渠道",
          "serviceLocation": {
            "@type": "Place",
            "name": "全国服务网点",
            "description": "覆盖全国30+地区"
          },
          "servicePhone": {
            "@type": "ContactPoint",
            "telephone": "400-050-6688",
            "contactType": "customer service",
            "availableLanguage": ["Chinese"]
          },
          "serviceSmsNumber": {
            "@type": "ContactPoint",
            "telephone": "400-050-6688",
            "contactType": "customer service"
          }
        },
        "hasOfferCatalog": {
          "@type": "OfferCatalog",
          "name": "眼健康服务项目",
          "itemListElement": [
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "设备安装调试",
                "description": "专业设备安装与调试服务"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "故障维修",
                "description": "快速响应设备故障维修"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "运维升级",
                "description": "设备运维与系统升级服务"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "技术咨询",
                "description": "专业技术咨询与解答"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "上门服务",
                "description": "上门现场服务支持"
              }
            },
            {
              "@type": "Offer",
              "itemOffered": {
                "@type": "Service",
                "name": "远程协助",
                "description": "线上远程技术协助"
              }
            }
          ]
        }
      };

      // FAQ 问答
      const faqData = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "优眼智家提供哪些服务？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "优眼智家提供设备安装调试、故障维修、运维升级、技术咨询等专业支持，支持上门现场服务和线上远程协助。"
            }
          },
          {
            "@type": "Question",
            "name": "优眼智家的服务覆盖范围？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "优眼智家服务覆盖全国30+地区，就近响应，高效对接您的多样化需求。"
            }
          },
          {
            "@type": "Question",
            "name": "优眼智家服务面向哪些客户？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "优眼智家服务于眼科机构、视光中心、眼镜门店、医疗机构及相关单位。"
            }
          },
          {
            "@type": "Question",
            "name": "如何联系优眼智家服务团队？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "您可以拨打客服热线400-050-6688联系我们，我们建立了快速响应通道，第一时间出具解决方案。"
            }
          }
        ]
      };

      // 注入到页面
      const dataList = [
        { id: 'breadcrumb', data: breadcrumbData },
        { id: 'servicepage', data: servicePageData },
        { id: 'coreservices', data: coreServicesData },
        { id: 'service', data: serviceData },
        { id: 'faq', data: faqData }
      ];

      dataList.forEach(item => {
        const script = document.createElement('script');
        script.id = `structured-data-service-${item.id}`;
        script.type = 'application/ld+json';
        script.textContent = JSON.stringify(item.data);
        document.head.appendChild(script);
      });
    },
    removeStructuredData() {
      const ids = ['breadcrumb', 'servicepage', 'coreservices', 'service', 'faq'];
      ids.forEach(id => {
        const script = document.getElementById(`structured-data-service-${id}`);
        if (script) document.head.removeChild(script);
      });
    },
    goHome() {
      this.$router.push('/uyu_home')
    },
    goProduct() {
      this.$router.push('/uyu_product');
    },
    goAbout() {
      this.$router.push('/uyu_about');
    }
  }
};
</script>
<style scoped lang="less" src="./assets/index.response.less" />